import React from 'react'
import Title from '../layouts/Title'
import { /*projectOne, projectTwo, projectThree,*/ KaiCertificate, Taekwondo,WadoCertificate } from "../../assets/index";
import AchievementsCard from './AchivementsCard';

const Achievements = () => {
  return (
    <section
      id="achievements"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          title="Certifications and Credentials"
          des="Achievements"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        <AchievementsCard
          title="KARATE ASSOCIATION OF INDIA"
          des=" The Karate India Organisation replaced Karate Association of India as the national 
          governing body for Karate in India on confirmation from World Karate Federation on 
          15 November 2021."
          src={KaiCertificate}
        />
        <AchievementsCard
          title="INDIAN WADORYU KARATE ASSOCIATION"
          des=" The International Wado Karate Do Federation India is the governing body for traditional 
          Wado/Wadoryu karate. The International Wado Federation of India (IWF INDIA) is the only 
          governing body in India that practices pure Wado karate do"
          src={WadoCertificate}
        />
        <AchievementsCard
          title="WORLD TAEKWONDO, KUKKIWON"
          des=" Kukkiwon, also known as World Taekwondo Headquarters, and home of the World Taekwondo Academy,
           is where the official taekwondo governing organization was established by the South Korean 
           government. It is supervised by the International Sports Division of the Ministry of Culture, 
           Sports, and Tourism."
          src={Taekwondo}
        />
        {/* <AchievementsCard
          title="SOCIAL MEDIA CLONE"
          des=" Lorem, ipsum dolor sit amet consectetur adipisicing elit.
              Explicabo quibusdam voluptate sapiente voluptatibus harum quidem!"
          src={WadoCertificate}
        /> */}
        {/* <AchievementsCard
          title="E-commerce Website"
          des=" Lorem, ipsum dolor sit amet consectetur adipisicing elit.
              Explicabo quibusdam voluptate sapiente voluptatibus harum quidem!"
          src={projectOne}
        />
        <AchievementsCard
          title="Chatting App"
          des=" Lorem, ipsum dolor sit amet consectetur adipisicing elit.
              Explicabo quibusdam voluptate sapiente voluptatibus harum quidem!"
          src={projectTwo}
        /> */}
      </div>
    </section>
  );
}

export default Achievements